export { default as FormikNumberInput } from './FormikNumberInput';
export type { FormikNumberInputProps } from './types';
